import Inspector from './inspector';
const { InnerBlocks } = wp.blockEditor;

const Edit = ({ attributes, setAttributes }) => {
  const { margin } = attributes;

  return (
    <>
      <Inspector attributes={attributes} setAttributes={setAttributes} />

      <div className={`Plans Plans-editPanel ${margin}`}>
        <div className="Container Container-PME">
          <div className="Plans-wrap Plans-companing">
            <div className="swiperPlansCompaning">
              <div className="swiper-wrapper">
                <InnerBlocks
                  template={[['app/plans-corporate-item']]}
                  allowedBlocks={['app/plans-corporate-item']}
                />
              </div>
            </div>

            <div className="Plans-wrapButtons wrapButtons-companing">
              <div class="Plans-antes"></div>
              <div class="Plans-depois"></div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Edit;
